import {RULE_VERSION, nawRuzDate, civilDateToBadi} from './index.js';

export const SUPPORTED_BAHAI_YEARS = Object.freeze({first: 172, last: 221});
export function readBahaiYear(value) {
  const year = typeof value === 'string' && /^badi:[1-9][0-9]*$/.test(value) ? Number(value.slice(5)) : value;
  if (!Number.isInteger(year) || year < SUPPORTED_BAHAI_YEARS.first || year > SUPPORTED_BAHAI_YEARS.last) throw new RangeError('Choose a supported Bahá’í year.');
  return year;
}
export function bahaiYearDefinition(value) {
  const number = readBahaiYear(value);
  const gregorianStartYear = number + 1843;
  return {id: `badi:${number}`, number, label: `${number} B.E.`, gregorianStartYear,
    startDate: nawRuzDate(gregorianStartYear), endDateExclusive: nawRuzDate(gregorianStartYear + 1), ruleVersion: RULE_VERSION};
}
export const bahaiYearDefinitions = () => Array.from({length: SUPPORTED_BAHAI_YEARS.last - SUPPORTED_BAHAI_YEARS.first + 1}, (_, index) => bahaiYearDefinition(index + SUPPORTED_BAHAI_YEARS.first));
export const bahaiYearForCivilDate = date => bahaiYearDefinition(civilDateToBadi(date).year);
export const bahaiYearLabel = value => {const year = bahaiYearDefinition(value); return `${year.label} (${year.gregorianStartYear}–${year.gregorianStartYear + 1})`;};
